import styled from "styled-components";
import { RaisedButton, IconToggle, IconToggleText } from "@evergis/ui";
import { FilterContainerProps, FilterScreenBreakpoint } from "../FiltersCollapsed/types";

interface ActionBlockProps {
  onClick: VoidFunction;
}

interface WithMarginProps {
  margin: string;
}

export const IconToggleFitContent = styled(IconToggle)`
  width: -moz-fit-content;
  width: -webkit-fit-content;
  width: fit-content;

  ${IconToggleText} {
    white-space: nowrap;
  }
`;

export const BarBlock = styled.div`
  display: flex;
  flex: 1 1 auto;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  padding: 0 1.5rem;
`;

export const BlankContent = styled.div<{ dialogStyled?: boolean }>`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  box-shadow: ${({ dialogStyled }) => (dialogStyled ? "0 -2px rgb(0 0 0 / 6%)" : "none")};
`;

export const ActionBlock = styled.span<ActionBlockProps>`
  color: ${({ theme: { palette } }) => palette.primary};
  margin-left: 1rem;
  cursor: pointer;
`;

export const QuickActionsBlock = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

export const TextBlock = styled.div`
  margin-right: 1rem;
  color: ${({ theme: { palette } }) => palette.textPrimary};
`;

export const WithMargin = styled.div<WithMarginProps>`
  margin: ${({ margin }) => margin};
`;

export const CategoryBlock = styled.div`
  display: flex;
  flex-direction: row;

  > * {
    margin-right: 1rem;
  }
`;

export const NewProjectButton = styled(RaisedButton)``;

export const FiltersAndSortsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
`;

export const FiltersAndSortsExpanded = styled.div<FilterContainerProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
  @media screen and (max-width: ${({ breakpoint = FilterScreenBreakpoint.All }) => `${breakpoint}rem`}) {
    display: none;
  }
`;
